<div *ngIf="!child"
     [ngClass]="{'calsoft-horizontal-navigation-menu-active': trigger.menuOpen}"
     [matMenuTriggerFor]="matMenu"
     (onMenuOpen)="triggerChangeDetection()"
     (onMenuClose)="triggerChangeDetection()"
     #trigger="matMenuTrigger">
    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
</div>

<mat-menu class="calsoft-horizontal-navigation-menu-panel"
          [overlapTrigger]="false"
          #matMenu="matMenu">

    <ng-container *ngFor="let item of item.children">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <div class="calsoft-horizontal-navigation-menu-item"
                 *ngIf="item.type === 'basic'"
                 mat-menu-item>
                <calsoft-horizontal-navigation-basic-item [item]="item"
                                                      [name]="name"></calsoft-horizontal-navigation-basic-item>
            </div>

            <!-- Branch: aside, collapsable, group -->
            <div class="calsoft-horizontal-navigation-menu-item"
                 *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'"
                 [matMenuTriggerFor]="branch.matMenu"
                 mat-menu-item>
                <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}"></ng-container>
                <calsoft-horizontal-navigation-branch-item [child]="true"
                                                       [item]="item"
                                                       [name]="name"
                                                       #branch></calsoft-horizontal-navigation-branch-item>
            </div>

            <!-- Divider -->
            <div class="calsoft-horizontal-navigation-menu-item"
                 *ngIf="item.type === 'divider'"
                 mat-menu-item>
                <calsoft-horizontal-navigation-divider-item [item]="item"
                                                        [name]="name"></calsoft-horizontal-navigation-divider-item>
            </div>

        </ng-container>

    </ng-container>

</mat-menu>

<!-- Item template -->
<ng-template let-item
             #itemTemplate>

    <div class="calsoft-horizontal-navigation-item-wrapper"
         [class.calsoft-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
         [ngClass]="item.classes">

        <div class="calsoft-horizontal-navigation-item"
             [ngClass]="{'calsoft-horizontal-navigation-item-disabled': item.disabled}">

            <!-- Icon -->
            <mat-icon class="calsoft-horizontal-navigation-item-icon"
                      [ngClass]="item.iconClasses"
                      *ngIf="item.icon"
                      [svgIcon]="item.icon"></mat-icon>

            <!-- Title & Subtitle -->
            <div class="calsoft-horizontal-navigation-item-title-wrapper">
                <div class="calsoft-horizontal-navigation-item-title">{{item.defaultName | titlecase}}</div>
                <div class="calsoft-horizontal-navigation-item-subtitle text-hint"
                     *ngIf="item.subtitle">
                    {{item.subtitle | titlecase}}
                </div>
            </div>

            <!-- Badge -->
            <div class="calsoft-horizontal-navigation-item-badge"
                 *ngIf="item.badge">
                <div class="calsoft-horizontal-navigation-item-badge-content"
                     [ngClass]="[(item.badge.style != undefined ? 'calsoft-horizontal-navigation-item-badge-style-' + item.badge.style : ''),
                             (item.badge.background != undefined && !item.badge.background.startsWith('#') ? item.badge.background : ''),
                             (item.badge.color != undefined && !item.badge.color.startsWith('#') ? item.badge.color : '')]"
                     [ngStyle]="{'background-color': item.badge.background, 'color': item.badge.color}">
                    {{item.badge.title | titlecase}}
                </div>
            </div>
        </div>
    </div>

</ng-template>
